import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { fetchData, deleteData, getDataById } from "../../utility/managerApi";
import Pagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import loader from "../../assets/loader.webp";
import AddUser from "./AddUser";
import EditUser from "./EditUser";

function Users() {
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addtab, setAddtab] = useState(false);
  const [edittab, setEdittab] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [singleData, setSingleData] = useState([]);
  const [userToDelete, setUserIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchUsers = async (page = 1, search = "") => {
    const response = await fetchData("users", currentPage, searchData);
    setUserData(response?.data?.data);

    setTotalPage(response?.data?.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  // Fetch data on page change or search query change
  useEffect(() => {
    fetchUsers(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  useEffect(() => {
    setCurrentPage(1);
    fetchUsers(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  const handleCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleAdd = () => {
    setAddtab(true);
    setEdittab(false);
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("users/show/", id);

    setSingleData(response.data.data);
    if (setEditTab) {
      setEdittab(true);
    } else {
      // setViewFile(true)
    }
  };

  const handleDelete = (id) => {
    setUserIdToDelete(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    await deleteData("users/delete/", userToDelete);
    fetchUsers(currentPage); //
    setIsModalOpen(false);
  };
  return (
    <div className=" lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between  items-center p-4 w-full">
        <h3 className="text-xl font-semibold">
          <PeopleOutlineIcon /> Users
        </h3>
        <div className="flex gap-6">
          <button
            onClick={() => {
              handleAdd();
            }}
            className="p-3 rounded-lg text-white bg-blue-500"
          >
            Add User <AddIcon />
          </button>{" "}
        </div>{" "}
      </div>
      {addtab && !edittab && (
        <AddUser
          setIsLoading={setIsLoading}
          setAddtab={setAddtab}
          fetchUsers={fetchUsers}
          currentPage={currentPage}
        />
      )}
      {edittab && !addtab && (
        <EditUser
          singleData={singleData}
          setSingleData={setSingleData}
          setEdittab={setEdittab}
          currentPage={currentPage}
          fetchUsers={fetchUsers}
        />
      )}
      {!edittab && !addtab && (
        <div className="w-full p-4 flex flex-col gap-2  bg-white">
          <div>
            <input
              placeholder="Search for"
              type="text"
              name="user_name"
              // id="email"
              value={searchData}
              onChange={handleChange}
              className="border-2 border-gray-400 w-60 p-2 px-6"
            />
          </div>
          <div className="w-full">
            {isLoading ? (
              <div className="  flex justify-center items-center">
                {" "}
                <img
                  src={loader}
                  alt="loader"
                  className=" w-10 lg:w-20 "
                />{" "}
              </div>
            ) : (
              <table className="min-w-full bg-white border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-4 border-b border-gray-300">
                      First Name
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      Last Name
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      Email
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      Address
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                      Phone Number
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300 text-wrap">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userData?.map((item) => (
                    <tr
                      key={item.id}
                      className="hover:bg-gray-100 border-b border-gray-300"
                    >
                      <td className="py-2 px-4 text-wrap">{item.firstname}</td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {item.lastname}
                      </td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {item.email}
                      </td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {item.address}
                      </td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {item.phoneno}
                      </td>
                      <td className="py-2 flex justify-center gap-3 px-2 ">
                        <EditIcon
                          onClick={() => handleSingleFile(item.id, true)}
                          className="text-blue-500 cursor-pointer"
                        />
                        <VisibilityIcon className="text-yellow-400" />
                        <DeleteIcon
                          onClick={() => handleDelete(item.id)}
                          className="text-red-500 cursor-pointer"
                        />
                      </td>
                      {/* <td className="py-2 px-4 flex gap-2 justify-center items-center">
                    <EditIcon
                      onClick={() => handleEdit(item.id)}
                      className="text-blue-600 cursor-pointer"
                    />
                    <DeleteIcon
                      onClick={() => handleDelete(item.id)}
                      className="text-red-600 cursor-pointer"
                    />
                    <BasicSwitches status={item.is_active} id={item.id} />
                  </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <Pagination
              onPageChange={handleCurrentPage}
              totalPage={totalPage}
              currentPage={currentPage}
              setIsNextLoading={setIsNextLoading}
              setIsPrevLoading={setIsPrevLoading}
              isPrevLoading={isPrevLoading}
              isNextLoading={isNextLoading}
            />
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Delete"
        text2="Are you sure you want to delete the user?"
      />
    </div>
  );
}

export default Users;
